const ACQUISITION = 'ACQUISITION';
const CAMPAIGN_ACQUISITION_FUNNEL = 'CAMPAIGN_ACQUISITION_FUNNEL';
const COUPON_CAMPAIGN = 'COUPON_CAMPAIGN';

const MAIN_SETUP = 'MAIN_SETUP';
const SUCCESS_PAGE = 'SUCCESS_PAGE';
const COMPLETE_PAGE = 'COMPLETE_PAGE';
const LANDING_PAGE = 'LANDING_PAGE';

export {
  ACQUISITION,
  CAMPAIGN_ACQUISITION_FUNNEL,
  COUPON_CAMPAIGN,
  MAIN_SETUP,
  SUCCESS_PAGE,
  COMPLETE_PAGE,
  LANDING_PAGE,
};
